import { render, staticRenderFns } from "./ChildrenWorks.vue?vue&type=template&id=d72d3062&scoped=true"
import script from "./ChildrenWorks.vue?vue&type=script&lang=js"
export * from "./ChildrenWorks.vue?vue&type=script&lang=js"
import style0 from "./ChildrenWorks.vue?vue&type=style&index=0&id=d72d3062&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72d3062",
  null
  
)

export default component.exports